/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Custompropertycount2Inputs */

const en_entity_custompropertycount2 = /** @type {(inputs: Entity_Custompropertycount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Property Count`)
};

const de_entity_custompropertycount2 = /** @type {(inputs: Entity_Custompropertycount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Property Anzahl`)
};

/**
* | output |
* | --- |
* | "Custom Property Count" |
*
* @param {Entity_Custompropertycount2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_custompropertycount2 = /** @type {((inputs?: Entity_Custompropertycount2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Custompropertycount2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_custompropertycount2(inputs)
	return de_entity_custompropertycount2(inputs)
});
export { entity_custompropertycount2 as "entity_customPropertyCount" }